import { render, staticRenderFns } from "./BaseTableSortBy.vue?vue&type=template&id=a0323f88&"
import script from "./BaseTableSortBy.vue?vue&type=script&lang=js&"
export * from "./BaseTableSortBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports